import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Get runtime config from window (injected by runtime-config script) or use build-time env vars
const getRuntimeConfig = (key) => {
  // Check for runtime config (injected at runtime in production)
  if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) {
    return window.__RUNTIME_CONFIG__[key];
  }
  // Fall back to build-time env vars (for development)
  return process.env[key];
};

// Firebase configuration
// Uses runtime config from Google Cloud Run when available, falls back to build-time env vars
const firebaseConfig = {
  apiKey: getRuntimeConfig('REACT_APP_FIREBASE_API_KEY') || "your-api-key",
  authDomain: getRuntimeConfig('REACT_APP_FIREBASE_AUTH_DOMAIN') || "your-project.firebaseapp.com",
  projectId: getRuntimeConfig('REACT_APP_FIREBASE_PROJECT_ID') || "your-project-id",
  storageBucket: getRuntimeConfig('REACT_APP_FIREBASE_STORAGE_BUCKET') || "your-project.appspot.com",
  messagingSenderId: getRuntimeConfig('REACT_APP_FIREBASE_MESSAGING_SENDER_ID') || "your-sender-id",
  appId: getRuntimeConfig('REACT_APP_FIREBASE_APP_ID') || "your-app-id"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firestore Database
export const db = getFirestore(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;

